import Vue from 'vue';
import VueSlider from 'vue-slider-component';

import { PaginationNavPlugin, CarouselPlugin, CollapsePlugin, FormFilePlugin, PaginationPlugin} from 'bootstrap-vue'
Vue.use(PaginationNavPlugin);
Vue.use(CarouselPlugin);
Vue.use(CollapsePlugin);
Vue.use(FormFilePlugin);
Vue.use(PaginationPlugin);

Vue.component('VueSlider', VueSlider);

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    firstDayOfWeek: 2,  // Monday
    locale: 'ru-Ru',
});

require('./components');
require('./../app');
